/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type EnrollmentListItemStatus = typeof EnrollmentListItemStatus[keyof typeof EnrollmentListItemStatus];


export const EnrollmentListItemStatus = {
  scheduled: 'scheduled',
  active: 'active',
  paused: 'paused',
  completed: 'completed',
  cancelled: 'cancelled',
  bounced: 'bounced',
  error: 'error',
} as const;
